/** Additive-cost portfolio choice; dispersion must be supplied explicitly. */
export function buildKappaHatFromVectors(
  countries: string[],
  kappaS: Record<string, number>,
  kappaD: Record<string, number>
): number[][] {
  const N = countries.length;
  const S = new Array(N).fill(1);
  const D = new Array(N).fill(1);
  countries.forEach((c, i) => {
    if (kappaS[c] !== undefined && kappaS[c] > 0) S[i] = kappaS[c];
    if (kappaD[c] !== undefined && kappaD[c] > 0) D[i] = kappaD[c];
  });

  const hat: number[][] = Array.from({ length: N }, () => new Array(N).fill(1));
  for (let n = 0; n < N; n++) {
    for (let i = 0; i < N; i++) {
      hat[n][i] = n === i ? 1 : S[n] * D[i];
    }
  }
  return hat;
}


export function buildLambdaPrimeFromKappaHat(lam: number[][], hatMatrix: number[][], eta: number, etaPrime: number = eta): number[][] {
  if (!(eta > 0) || !Number.isFinite(eta) || !(etaPrime > 0) || !Number.isFinite(etaPrime)) throw new Error('Supply positive baseline and counterfactual dispersion.');
  return lam.map((row, n) => {
    if (!(row[n] > 0)) throw new Error('Domestic shares must be positive.');
    const logits = row.map((share, i) => {
      if (share === 0) return -Infinity;
      const cost = 1 - eta * Math.log(share / row[n]);
      const h = n === i ? 1 : hatMatrix[n][i];
      if (!(cost > 0) || !(h > 0) || !Number.isFinite(h)) throw new Error('Shares and dispersion must imply positive costs.');
      return -cost * h / etaPrime;
    });
    const max = Math.max(...logits);
    const values = logits.map(v => Math.exp(v - max));
    const total = values.reduce((a,b) => a+b, 0);
    return values.map(v => v/total);
  });
}
